type TEndpoint = string;
type TOptEnd = { v?: 'v1' | 'v2', query?: Record<string, string> }
type TOptEndV2 = {  query?: Record<string, string> }

type TStudentType = 'CERVO' | "XCELENCE" | 'CEIBA' | 'NOGAM3' | 'NOGAM4' | 'NOGAM5' | 'NOGAM6'
  | 'TEK3ESO'
  | 'TEK4ESO'
  | 'TEK1BAC'
  | 'TEK2BAC'
  | 'TEKFPB'
  | 'TEKFPM'

const processEndpoint = (endpoint: TEndpoint, options: TOptEnd) => {
  const { v = 'v1', query = {} } = options! || {}

  let _queryString = ''
  if (query) {
    const params = new URLSearchParams(query);
    const queryStringValue = params.toString()
    if (queryStringValue) _queryString = '?' + queryStringValue
  }

  return `/${v}${endpoint}${_queryString}`
}

const processEndpointV2 = (endpoint: TEndpoint, options?: TOptEnd) => {
  const { query = {} } = options || {}

  let _queryString = ''
  if (query) {
    const params = new URLSearchParams(query);
    const queryStringValue = params.toString()
    if (queryStringValue) _queryString = '?' + queryStringValue
  }

  return `${endpoint}${_queryString}`
}


const endpoint = {
  studentAnswer: {
    getAll: (type: TStudentType, option: TOptEnd): TEndpoint => processEndpoint(`/student/answers/${type}`, option)
  },
  v2: {
    studentAnswer: {
      getAll: (type: TStudentType, option: TOptEndV2): TEndpoint => processEndpointV2(`/v2/student/answers/${type}`, option)
    }
  }
}

export default endpoint